module.exports = "'use strict';\nvar regexpExec = require('./_regexp-exec');\nrequire('./_export')({\n  target: 'RegExp',\n  proto: true,\n  forced: regexpExec !== /./.exec\n}, {\n  exec: regexpExec\n});\n"


//////////////////
// WEBPACK FOOTER
// ../~/raw-loader!../~/core-js/modules/es6.regexp.exec.js
// module id = 968
// module chunks = 0